// import { useState } from "react";
// import { useAuth } from "../../../context/AuthContext";
// import { useTelegram } from "../../../hooks/useTelegram";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import TelegramBottomNav from "./TelegramBottomNav";

// export default function Layout({ children }) {
//   const { user } = useAuth();
//   const { isTelegram } = useTelegram();

//   return (
//     <div className="min-h-screen flex flex-col bg-transparent relative">
//       {/* Top Navbar */}
//       {!isTelegram && (
//         <div className="sticky top-0 z-40 relative">
//           <Navbar />
//         </div>
//       )}

//       <div className="flex flex-1 relative z-10">
//         {/* Main content */}
//         <main
//           className={`relative flex flex-col flex-1 transition-all duration-300 ease-out
//           ${isTelegram ? "pb-20" : ""}`}
//         >
//           {/* content container - grows to fill space */}
//           <div className="w-full flex-1">{children}</div>

//           {!isTelegram && (
//             <div className="border-t bg-transparent backdrop-blur-sm mt-auto">
//               <Footer />
//             </div>
//           )}
//         </main>
//       </div>

//       {/* Telegram bottom nav */}
//       {isTelegram && user && <TelegramBottomNav />}
//     </div>
//   );
// }

import { useAuth } from "../../../context/AuthContext";
import { useTelegram } from "../../../hooks/useTelegram";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import TelegramBottomNav from "./TelegramBottomNav";

export default function Layout({ children }) {
  const { user } = useAuth();
  const { isTelegram } = useTelegram();
  const isApplier = user?.role === "APPLIER";

  return (
    <div className="min-h-screen flex flex-col relative z-[1]">
      {!isTelegram && (
        <div className="sticky top-0 z-40 relative">
          <Navbar />
        </div>
      )}

      <div className="flex flex-1 relative min-w-0">
        <main
          className={`relative flex flex-col flex-1 transition-all duration-300 ease-out w-full min-w-0 bg-transparent
          ${isTelegram ? "pb-20" : isApplier ? "pb-16 md:pb-0" : ""}`}
        >
          <div className="w-full flex-1 min-w-0 bg-transparent">{children}</div>

          {!isTelegram && (
            <div className={`mt-auto w-full bg-transparent ${isApplier ? "pb-16 md:pb-0" : ""}`}>
              <Footer />
            </div>
          )}
        </main>
      </div>

      {isTelegram && user && <TelegramBottomNav />}
      {!isTelegram && isApplier && <BottomNav />}
    </div>
  );
}